import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

//Components
import CarPricingAIForm from '../AIFeatures/OpenAI/Owner/CarPricingAIForm';
import ReservationMessage from '../AIFeatures/OpenAI/Renter/ReservationMessage';

//Helper
import messages from '../../locale/jsonMessages';
import { closeAIModal } from '../../actions/modalActions';


//Images
import { AIIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';
import ListingTitleDescriptionForm from '../AIFeatures/OpenAI/Owner/ListingTitleDescriptionForm';
import { formValueSelector, getFormValues } from 'redux-form';
import { getLocation } from '../AIFeatures/Helper/getListingData';
//Styles
import cs from '../../components/commonStyle.css';

const CommonModal = ({ title, formName, formValues, currentIndex }) => {

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();

    const isOpenAIModal = useSelector(state => state?.modalStatus?.isOpenAIModal);
    const data = useSelector((state) => getFormValues('ListPlaceStep1')(state)) || {};
    const dynamicListSelector = formValueSelector('ListPlaceStep2')
    const dynamicListDetails = useSelector(state => dynamicListSelector(state, 'dynamicListTitleDescription'))
    const language = dynamicListDetails && dynamicListDetails[currentIndex]?.language;

    const location = getLocation(data);

    const renderForm = () => {
        switch (formName) {
            case 'CarPricingWithAI':
                return <CarPricingAIForm />;
            case 'reservationMessage':
                return <ReservationMessage initialValues={formValues} formValues={formValues} />;
            case 'ListingTitleDescriptionForm':
                return <ListingTitleDescriptionForm currentAIIndex={currentIndex} initialValues={{
                    ...formValues, currentIndex, language, preferences: [
                        { id: 1, name: "location", value: location }
                    ]
                }} />
        }
    };

    const closeModal = () => {
        dispatch(closeAIModal())
    }

    return (
        <Modal show={isOpenAIModal} onHide={closeModal} dialogClassName='commonModalContainer commonAiModalContainer'>
            <Modal.Header className='commonModalHeader' closeButton>
                <Modal.Title className='commonModalTitle isolate'>
                    {title}&nbsp;
                    <span className={cx(cs.aiBadgeStyle, cs.top3)}>
                        <AIIcon />
                        <span className={cs.aiTextColor}>AI</span>
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass='commonModalBody'>
                {renderForm(formName)}
            </Modal.Body>
            <Modal.Footer className='commonAiModalFooter'>
                <span className={cs.aiFooterInfoText}><span className={cs.fontWeightExtraBold}>{formatMessage(messages.aiDeclaimerLabelOne)}</span>&nbsp;{formatMessage(messages.aiDeclaimerLabelTwo)}</span>
            </Modal.Footer>
        </Modal>
    )
}

export default (withStyles(cs)(CommonModal));
